import { Line } from "react-chartjs-2";
// Bootstrap
import "bootstrap-icons/font/bootstrap-icons.css";
import styleDate from "../../util/dateStyler";

import { BiCheckCircle } from "react-icons/bi";

import SampleCons from "../../constants/sample";
import {
  SCAN_CHECK,
  ADVISORY_CARD_STYLE,
  getScanCheckResult,
  getSignalQualityText,
} from "../../util/scanCheck";

// TODO: remove getAnalyteName and addSpaces once legacy `substance` format is retired
const getAnalyteName = (analyte) => {
  return (
    SampleCons.ANALYTE_NAMES.find((item) => item.modelName === analyte)
      ?.displayName || addSpaces(analyte)
  );
};

//add spaces between camel case
const addSpaces = (string) => {
  return string.replace(/(?!\[)([^A-Z])([A-Z])(?![A-Z])/g, "$1 $2").trim();
};

export function SequenceB({ findings }) {
  return (
    <>
      {Array.isArray(findings) && findings.length > 0 ? (
        <div className='border border-3 rounded bg-light fs-6 fw-semibold w-75 me-0 me-sm-5 p-2'>
          <ul className='mb-0'>
            {findings.map((finding, index) => (
              <li key={index} className=''>
                {/* TODO: remove legacy `substance` fallback once old sample format is retired */}
                {finding.substanceCustomer ?? getAnalyteName(finding.substance)}{" "}
                {finding.pureSubstance && finding.pureSubstance === "Yes" && (
                  <small>
                    <i className='text-success'>*High purity</i>
                  </small>
                )}
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <p>Skipped</p>
      )}
    </>
  );
}

export function SequenceC({ adverse, checked, add, remove, prevSelect }) {
  const handleSelect = () => {
    if (!checked && !prevSelect) {
      add(adverse);
    }
    if (checked || prevSelect) {
      remove(adverse.id);
    }
  };

  return (
    <div
      className={checked ? "btn btn-secondary" : "btn btn-outline-secondary"}
      onClick={() => handleSelect()}
    >
      {adverse.label}
    </div>
  );
}

export function SequenceD({ findings }) {
  return (
    <div className='border bg-light p-1'>
      {findings.length > 0 && typeof findings[0] === "string" ? (
        <ul className='font-weight-bold align-middle mb-0 ps-4'>
          {findings.map((finding, index) => (
            <p className='mb-0 font-weight-bold' key={index}>
              <li>{getAnalyteName(finding)} </li>
            </p>
          ))}
        </ul>
      ) : (
        <p className='text-center mb-0'>No scan</p>
      )}
    </div>
  );
}

export function SequenceE({ sequence, valid, onSelect, isSelected }) {
  // Unknown results come back as Warning, so they get the orange card
  const scanQuality = getScanCheckResult(sequence.errorCheck);
  const signalQuality = getSignalQualityText(sequence.errorCheck);

  const handleSelect = () => {
    onSelect(sequence);
  };

  // Round the wavenumber_plot values to the nearest 100s
  const roundedWavenumbers = sequence.wavenumber_plot.map(
    (value) => Math.round(value / 100) * 100,
  );

  const spectraChartData = {
    labels: roundedWavenumbers,
    datasets: [
      {
        label: "Spectra Scan",
        data: sequence.processed_data_plot,
        fill: false,

        borderColor: "#0093EA",
        tension: 0.1,
      },
    ],
  };

  const graphOptions = {
    responsive: true,
    maintainAspectRatio: true,
    aspectRatio: 3,
    scales: {
      x: {
        title: {
          display: true,
          text: "Raman shift (cm^-1)",
        },
      },
      y: {
        title: {
          display: true,
          text: "Intensity (a.u.)",
        },
      },
    },
    elements: {
      point: {
        radius: 1,
      },
    },
    plugins: {
      legend: {
        align: "end",
        display: false,
        labels: {
          boxWidth: 10,
        },
        onHover: function (e) {
          e.native.target.style.cursor = "pointer";
        },
        onLeave: function (e) {
          e.native.target.style.cursor = "default";
        },
      },
    },
  };

  return (
    <label
      className={`shadow card h-100 d-flex flex-grow-1 border-3 sequence-card`}
      style={{
        backgroundColor: isSelected ? "#F4FAFE" : "",
        borderColor: isSelected ? "#0E8FDA" : "",
      }}
      onClick={handleSelect}
    >
      <div className=' card-body h-100 d-flex flex-column flex-grow-1 justify-content-between'>
        <div className=' d-flex flex-column align-items-center h-100'>
          <div className='d-flex align-items-center justify-content-between w-100'>
            <div>
              <strong>Scan Number:&nbsp; </strong> {sequence.scanId}
            </div>
            <div>
              <strong>Date:&nbsp; </strong> {styleDate(sequence.date)}
            </div>
          </div>
          <div className='d-flex align-items-center justify-content-center flex-grow-1 w-100'>
            <Line data={spectraChartData} options={graphOptions} />
          </div>
        </div>
        <div className='d-flex flex-column align-items-center justify-content-center'>
          {scanQuality === SCAN_CHECK.ANALYTE && (
            <div className='d-flex mb-2'>
              <BiCheckCircle // Green checkmark icon
                style={{
                  fontSize: "x-large",
                  color: "green",
                  marginRight: "10px",
                }}
              />
              <strong>Good scan! Submit for analysis.</strong>
            </div>
          )}

          {scanQuality === SCAN_CHECK.ADVISORY && (
            <div className='row'>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <div
                  className={ADVISORY_CARD_STYLE.iconClass}
                  role='img'
                  aria-label='Information'
                  style={{
                    fontSize: "large",
                    color: ADVISORY_CARD_STYLE.color,
                    marginRight: "10px",
                    marginBottom: "2px",
                  }}
                ></div>
                <strong>{signalQuality}</strong>
              </div>
            </div>
          )}

          {scanQuality === SCAN_CHECK.ERROR && (
            <div className='row'>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  // marginTop: "30px",
                }}
              >
                <div
                  className='bi-exclamation-square-fill'
                  style={{
                    fontSize: "large",
                    color: "red",
                    marginRight: "10px",
                    marginBottom: "2px",
                  }}
                ></div>
                {sequence.errorCheck?.signalQuality ===
                  "out of training distrubution" ? (
                  <strong>
                    Complex spectrum. Reachback support recommended
                  </strong>
                ) : (
                  <strong>{signalQuality}</strong>
                )}
              </div>
            </div>
          )}

          {scanQuality === SCAN_CHECK.WARNING && (
            <div className='row'>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  // marginTop: "30px",
                }}
              >
                <div
                  className='bi-exclamation-triangle-fill'
                  style={{
                    fontSize: "large",
                    color: "orange",
                    marginRight: "10px",
                    marginBottom: "2px",
                  }}
                ></div>
                <strong>Warning: {signalQuality}</strong>
              </div>
            </div>
          )}

          {scanQuality === SCAN_CHECK.NOT_AVAILABLE && (
            <div className='row'>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  // marginTop: "30px",
                }}
              >
                <div
                  className='bi-exclamation-square-fill'
                  style={{
                    fontSize: "large",
                    color: "orange",
                    marginRight: "10px",
                    marginBottom: "2px",
                  }}
                ></div>
                <strong>Scan quality not available</strong>
              </div>
            </div>
          )}

          {/* {sequence.subScans[0]?.errorCheck?.errorFlag === 0 && ( */}
        </div>
      </div>
    </label>
  );
}

export function SequenceEB({ sequence }) {
  // Round the wavenumber_plot values to the nearest 100s
  const roundedWavenumbers = sequence.wavenumber_plot.map(
    (value) => Math.round(value / 100) * 100,
  );

  const spectraChartData = {
    labels: roundedWavenumbers,
    datasets: [
      {
        label: "Spectra Scan",
        data: sequence.processed_data_plot,
        fill: false,

        borderColor: "#0093EA",
        tension: 0.1,
      },
    ],
  };

  const graphOptions = {
    responsive: true,
    maintainAspectRatio: true,
    aspectRatio: 3,
    scales: {
      x: {
        title: {
          display: true,
          text: "Raman shift (cm^-1)",
        },
      },
      y: {
        title: {
          display: true,
          text: "Intenisty (a.u.)",
        },
      },
    },
    elements: {
      point: {
        radius: 1,
      },
    },
    plugins: {
      legend: {
        align: "end",
        display: false,
        labels: {
          boxWidth: 10,
        },
        onHover: function (e) {
          e.native.target.style.cursor = "pointer";
        },
        onLeave: function (e) {
          e.native.target.style.cursor = "default";
        },
      },
    },
  };

  return (
    <label className={`card shadow-sm border-3`}>
      <div className='card-body '>
        <div className='d-flex justify-content-between'>
          <div>
            <strong>Scan Number: </strong> {sequence.scanId}
          </div>
          <div>
            <strong>Date: </strong> {styleDate(sequence.date)}
          </div>
        </div>
        <div style={{ maxWidth: "100%" }}>
          <Line data={spectraChartData} options={graphOptions} />
        </div>
      </div>
    </label>
  );
}

export function SequenceF({ deviceID, sequenceId, date }) {
  return (
    <div className='shadow-sm p-2'>
      <div>
        {sequenceId ? (
          <div className='d-flex flex-row'>
            {/* <div className='col text-muted'>{deviceID}</div> */}
            <div className='col text-muted'>Scan #{sequenceId}</div>
            <small className='font-weight-bold'>{date}</small>
          </div>
        ) : (
          <div>
            {/* <div className='text-muted'>{deviceID}</div> */}
            <small className='font-weight-bold'>{date}</small>
          </div>
        )}
      </div>
    </div>
  );
}

export function SequenceRadio({ flag, checked, select }) {
  return (
    <div>
      <input
        className='form-check-input'
        type='radio'
        name={flag}
        id={flag}
        checked={checked}
        onChange={() => select(flag)}
      />
      <label className='form-check-label' htmlFor={flag}>
        {flag === "" ? "N/A" : `${flag}`}
      </label>
    </div>
  );
}
export function SequenceRadioB({ name, value, id, checked, onChange }) {
  return (
    <div>
      <input
        className='form-check-input'
        type='radio'
        name={name}
        value={value}
        id={id}
        checked={checked}
        onChange={onChange}
      />
      <label className='form-check-label' htmlFor={id}>
        {value === "" ? "N/A" : `${value}`}
      </label>
    </div>
  );
}
